/** @jsx jsx */
import { jsx } from '@emotion/core';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Picture from '../../ui/Picture';
import defaultsDeep from 'lodash/defaultsDeep';
import createButtonCss from '../../ui/Button/Button';
import { Container, Row, Column } from '../../../styles/Grid';
import DotComponent from '../../ui/DotComponent';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import { withNamespaces } from 'react-i18next';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerMarginCss,
  thankyouHeadlineCss,
  thankYouImageContainerCss,
  thankYouImageCss,
  thankYouPictureCss,
  imageColumnCss,
  mainContainerCss,
  buttonCss,
} from './index.styles';

const thankYouImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '15:19',
    width: 294,
    height: 376,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '64:83',
    width: 638,
    height: 828,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '64:83',
    width: 597,
    height: 775,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '64:83',
    width: 597,
    height: 775,
  },
};

const defaultData = {
  ThankYouViewImage: {
    value: {
      src: '',
      alt: '',
    },
  },
  children: () => {},
  closeModal: () => {},
  t: () => {},
  isModal: false,
};

export class ThankYouImage extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props, defaultData);
    const { ThankYouViewImage, closeModal, t, isModal } = fields;
    const { children, disableCloudinary } = props;

    return (
      <Container css={mainContainerCss}>
        <Row>
          <Column
            cols={{ sm: 4, md: 7, lg: 6, xl: 12 }}
            offsets={{ sm: 1, md: 1, lg: 0, xl: 1 }}
          >
            <div css={containerMarginCss}>
              <h1 css={thankyouHeadlineCss}>
                {t('ThankYouViewHeading')}
                <DotComponent />
              </h1>
              {children}
              {isModal && (
                <button
                  css={[createButtonCss('secondary'), buttonCss]}
                  onClick={closeModal}
                >
                  {t('ThankYouViewCloseCta')}
                </button>
              )}
            </div>
          </Column>
          <Column
            css={imageColumnCss}
            cols={{ sm: 5, md: 7 }}
            offsets={{ sm: 1, md: 1 }}
          >
            <div css={thankYouImageContainerCss}>
              {disableCloudinary ? (
                <picture css={thankYouPictureCss}>
                  <img
                    css={thankYouImageCss}
                    src={get(ThankYouViewImage, 'value.src')}
                    alt={get(ThankYouViewImage, 'value.alt')}
                  />
                </picture>
              ) : (
                <Picture
                  image={ThankYouViewImage}
                  imageSizes={thankYouImageSizes}
                  imageCss={thankYouImageCss}
                  pictureCss={thankYouPictureCss}
                />
              )}
            </div>
          </Column>
        </Row>
      </Container>
    );
  }
}

ThankYouImage.displayName = 'ThankYouImage';

ThankYouImage.propTypes = {
  children: PropTypes.element,
  ThankYouViewImage: PropTypes.shape({
    value: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
  closeModal: PropTypes.func,
  t: PropTypes.func,
  isModal: PropTypes.bool,
};

// Excludes ErrorBoundary due issues with children
export default compose(withNamespaces())(ThankYouImage);
